import React, { useState } from 'react';
import EastEndLogo from '../EastEndCemetery_white.png';
import './Welcome.css';

const Welcome = () => {
  const [welcomeIsOpen, setWelcomeIsOpen] = useState(true);

  if (!welcomeIsOpen) {
    return null;
  }

  return (
      <div
        id="welcome"
      >
        <img src={EastEndLogo} alt="East End Cemetery logo" />
        <p>East End Cemetery (est. 1897) is a historic African American burial ground in Henrico County and the city of Richmond, Virginia. From 2013 to 2020, volunteers led by the Friends of East End worked to reclaim the 16-acre cemetery from nature and neglect.</p>
        <p>Years in the making, this map pinpoints the locations of grave markers at East End using GIS technology and drone imagery. As of July 2021, more than 3,300 markers had been mapped, with points indicating their precise positions in the cemetery. Points will continue to be added as markers are found.</p>
        <button
          onClick={() => setWelcomeIsOpen(false)}
        >
          Explore the Map
        </button>
      </div>
  );
};

export default Welcome;




// WEBPACK FOOTER //
// ./src/components/Welcome.jsx